import { motion } from 'framer-motion';

const WhyTrripHeader = ({ isResolved }) => {
  return (
    <div className="text-center max-w-3xl mx-auto space-y-4 mb-12 relative z-20">
      <motion.div
        initial={false}
        animate={{
          backgroundColor: 'rgba(6, 121, 120, 0.08)',
          color: '#067978',
          borderColor: 'rgba(6, 121, 120, 0.2)'
        }}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-full border font-bold text-[10px] uppercase tracking-widest mb-4"
      >
        THE ON-TRIP GAP
      </motion.div>

      <h2 className="text-2xl md:text-4xl font-bold text-[#1a2b49] tracking-tight leading-tight transition-all duration-700">
        You planned the trip. <br />
        <span className={isResolved ? 'text-[#067978]' : 'text-[#067978]'}>
          Don't disappear during it.
        </span>
      </h2>

      <p className="text-[#067978] text-base md:text-lg font-normal transition-all duration-700 max-w-2xl mx-auto pt-2">
        Once the trip starts, you lose your client, your visibility, and every chance to add value
        to the relationship.
      </p>
    </div>
  );
};

export default WhyTrripHeader;
